if (!customElements.get('soso-fixed-bundle-picker')) {
  customElements.define('soso-fixed-bundle-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        this.variantSelect.form?.addEventListener('submit', this.onSubmit);
        return;
      }
      this.ready = true;
      this.selectors = [...this.querySelectorAll('[data-bundle-option]')];
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.variants = [...this.variantSelect.options].filter(option => option.dataset.bundleOptions).map(option => ({ option, values: JSON.parse(option.dataset.bundleOptions), available: option.dataset.available === 'true' }));
      this.sharedSelect = this.querySelector('[data-bundle-size-all]');
      this.mixedToggle = this.querySelector('[data-bundle-mixed]');
      this.sharedFields = this.querySelector('[data-bundle-shared]');
      this.individualFields = this.querySelector('[data-bundle-individual]');
      this.summary = this.querySelector('[data-bundle-summary]');
      this.button = document.getElementById(this.variantSelect.dataset.buttonTarget);
      const initial = this.selectors.map(select => select.value);
      const hasChoice = initial.every(Boolean);
      this.mixedToggle.checked = hasChoice && !initial.every(value => value === initial[0]);
      this.sharedSelect.value = hasChoice && !this.mixedToggle.checked ? initial[0] : '';
      this.mixedToggle.disabled = false;
      this.sharedSelect.addEventListener('change', () => {
        this.selectors.forEach(select => { select.value = this.sharedSelect.value; });
        this.update(true);
      });
      this.mixedToggle.addEventListener('change', () => {
        const values = this.selectors.map(select => select.value);
        if (!this.mixedToggle.checked) this.sharedSelect.value = values.every(value => value === values[0]) ? values[0] : '';
        this.setMode();
        this.update(true);
      });
      this.selectors.forEach(select => select.addEventListener('change', () => this.update(true)));
      this.onSubmit = event => {
        if (!this.currentVariant?.available) {
          event.preventDefault();
          (this.mixedToggle.checked ? this.selectors.find(select => !select.value) || this.selectors[0] : this.sharedSelect).focus();
        }
      };
      this.variantSelect.form?.addEventListener('submit', this.onSubmit);
      this.setMode();
      this.update(false);
    }
    disconnectedCallback() {
      this.variantSelect?.form?.removeEventListener('submit', this.onSubmit);
    }
    setMode() {
      const mixed = this.mixedToggle.checked;
      this.sharedFields.hidden = mixed;
      this.sharedSelect.disabled = mixed;
      this.individualFields.hidden = !mixed;
      this.individualFields.disabled = !mixed;
      this.selectors.forEach(select => { select.disabled = !mixed; });
    }
    update(notify) {
      const mixed = this.mixedToggle.checked;
      const chosen = mixed ? this.selectors.map(select => select.value) : this.selectors.map(() => this.sharedSelect.value);
      const complete = chosen.every(Boolean);
      for (const option of this.sharedSelect.options) {
        option.disabled = option.value !== '' && !this.variants.some(variant => variant.available && variant.values.every(value => value === option.value));
      }
      for (let index = 0; index < this.selectors.length; index++) {
        for (const option of this.selectors[index].options) {
          option.disabled = option.value !== '' && !this.variants.some(variant => variant.available && variant.values[index] === option.value && chosen.every((value, other) => other === index || value === '' || variant.values[other] === value));
        }
      }
      this.currentVariant = complete ? this.variants.find(variant => variant.values.every((value, index) => value === chosen[index])) : null;
      this.variantSelect.value = this.currentVariant ? this.currentVariant.option.value : '';
      this.summary.textContent = complete && !this.currentVariant?.available ? this.dataset.unavailable : '';
      // Keep the existing price, quantity, URL and sticky-purchase integrations.
      if (notify) this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      if (this.button) {
        this.button.disabled = !this.currentVariant?.available;
        this.button.textContent = !complete ? (mixed ? this.dataset.chooseAll : this.dataset.chooseSize) : this.button.disabled ? this.button.dataset.sold : this.button.dataset.add;
      }
    }
  });
}
